import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Spinner, Alert, Tab } from "react-bootstrap";
import MSCDItem from "./StaticCovidDataItem_En";
import { TimeSeriesChart } from "../modeling/components/TimeSeriesChart";

const variants = {
  visible: (custom) => ({ opacity: 1, y: 0, transition: { delay: custom * 0.2 } }),
  hidden: { opacity: 0, y: 100 },
};

const toInt = (v) => {
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
};

const yearOf = (r) => {
  const y = parseInt(r.year != null ? r.year : r.date, 10);
  return Number.isFinite(y) ? y : null;
};

const yearPoints = (rows, key) =>
  rows
    .map((r) => {
      const y = yearOf(r);
      return y != null ? [Date.UTC(y, 0, 1), toInt(r[key])] : null;
    })
    .filter((p) => p != null);

const StaticTubData_En = (props) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [pickedYear, setPickedYear] = useState("");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(false);
    axios
      .get(props.region.hr)
      .then((res) => {
        if (!alive) return;
        const data = Array.isArray(res.data) ? res.data : [];
        setRows(data);
        setPickedYear(data.length ? String(yearOf(data[data.length - 1])) : "");
        setLoading(false);
      })
      .catch((err) => {
        if (!alive) return;
        console.log(err);
        setError(true);
        setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [props.region.hr]);

  const years = rows.map(yearOf).filter((y) => y != null);
  const current = rows.find((r) => String(yearOf(r)) === String(pickedYear));

  const box = (name, key) => {
    if (loading) return { name, loading: true };
    const v = current ? toInt(current[key]) : null;
    return v === null
      ? { name, noData: true, lastDatadate: pickedYear }
      : { name, value: v, lastDatadate: pickedYear };
  };

  const lasts = [
    { id: 1, ...box("disease cases", "diagnoses") },
    { id: 2, ...box("fatal outcomes", "deaths") },
  ];

  const series = [
    { name: "Incidence", data: yearPoints(rows, "diagnoses"), color: "#00bfff" },
    { name: "Mortality", data: yearPoints(rows, "deaths"), color: "#8000ff" },
  ];

  return (
    <Tab.Pane eventKey={props.region.eventKey}>
      <div className="mx-3 my-3">
        <div className="mb-3 d-flex align-items-center" style={{ gap: 8 }}>
          <span className="text-muted">As of</span>
          <select
            className="form-select"
            style={{ maxWidth: 140 }}
            value={pickedYear}
            onChange={(e) => setPickedYear(e.target.value)}
            disabled={loading}
          >
            {years.map((y) => (
              <option key={y} value={String(y)}>
                {y}
              </option>
            ))}
          </select>
        </div>
        <Container>
          <Row style={{ width: "100%" }}>
            {lasts.map((item, index) => (
              <MSCDItem
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.05 }}
                custom={index + 1}
                variants={variants}
                key={item.id}
                last={item}
              />
            ))}
          </Row>
        </Container>
        <div className="my-4">
          {loading ? (
            <div style={{ height: 420, position: "relative" }}>
              <Spinner style={{ position: "absolute", top: "45%", left: "50%" }} animation="border" variant="info" />
            </div>
          ) : error ? (
            <Alert variant="danger" className="my-5">
              <Alert.Heading>Loading error</Alert.Heading>
              The server is temporarily unavailable, please refresh the page or try again later.
            </Alert>
          ) : (
            <TimeSeriesChart
              title="Tuberculosis — incidence and mortality"
              series={series}
              yAxisTitle="People"
              language="en"
            />
          )}
        </div>
      </div>
    </Tab.Pane>
  );
};

export default StaticTubData_En;
